<template>
<vx-card class='vx-col w-full mt-4'>
    <!-- <div class="vx-col w-full "> -->
    <div class=" text-right">
        <vs-button @click="f_salir()" class="mr-3 mb-2">Cerrar sesión</vs-button>
    </div>
    <vs-tabs>
        <vs-tab label="Cuenta">
            <Perfil />
        </vs-tab>
        <vs-tab label="Contraseña">
            <Resetear_password />
        </vs-tab>
    </vs-tabs>
</vx-card>
</template>

<script>
import Perfil from './perfil.vue';
import Resetear_password from './resetear_password.vue';

export default {
    components: {
        Perfil,
        Resetear_password,
    },
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {
        async f_salir() {
            localStorage.clear();
            this.$router.push('/');
            // location.reload()
        },
    }
};
</script>
